import { render, staticRenderFns } from "./BulkProductGridItem.vue?vue&type=template&id=d55587ca&scoped=true&"
import script from "./BulkProductGridItem.vue?vue&type=script&lang=js&"
export * from "./BulkProductGridItem.vue?vue&type=script&lang=js&"
import style0 from "./BulkProductGridItem.vue?vue&type=style&index=0&id=d55587ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55587ca",
  null
  
)

export default component.exports